<div #promobanner id="promobanner" [class.d-none]="!isPromoBannerEnabled" class="promo-banner fixed-top">
  <div class="pe-5 m-0" [innerHTML]="banner | safe: 'html'"></div>
  <button (click)="onClicked()" class="close-btn">&times;</button>
</div>
